import {Fields} from '../types'

const buildRangeErrorCodes = (field: Fields) => ({
  required: `${field}-required`,
  notAllowed: `${field}-not-allowed`,
  outOfRange: `${field}-out-of-range`,
  invalidStep: `${field}-invalid-step`
})

const buildCommonErrorCodes = (field: Fields) => ({
  required: `${field}-required`
})

export const ErrorCodes = {
  timeOnJobSite: buildRangeErrorCodes('timeOnJobSite'),
  flowRate: buildRangeErrorCodes('flowRate'),
  spacing: buildRangeErrorCodes('loadSpace'),
  retarder: buildRangeErrorCodes('retarder'),
  concreteUsage: buildRangeErrorCodes('concreteUsage'),
  quantity: buildRangeErrorCodes('quantity'),
  maxLoadSize: buildRangeErrorCodes('maxLoadSize'),
  plusLoad: buildCommonErrorCodes('plusLoadExpected'),
  additionalNotes: buildCommonErrorCodes('additionalNotes'),
  poNumber: buildCommonErrorCodes('poNumber'),
  driverInstructions: buildCommonErrorCodes('driverInstructions'),
  fullLoad: {
    notEnabled: 'fullLoad-not-enabled',
    invalidCount: 'fullLoad-invalid-count',
    staleOption: 'fullLoad-stale-option'
  }
} as const

export const ContactErrorCodes = {
  contactInvalidNameAndPhoneNumber: 'contact-invalid-name-and-phone-number',
  contactInvalidPhoneNumber: 'contact-invalid-phone-number',
  contactInvalidName: 'contact-invalid-name',
  contactPhoneNumberRequired: 'contact-phone-number-required',
  contactNameRequired: 'contact-name-required'
}
